export const DOC_BLOCKERS = {
	HOURS: 'hours_block',
	PAYMENT: 'payment_kdr_block',
};
